// FicheAppointment — demande de rendez-vous depuis une fiche AYA (v5.15.0).
// Générique : visible uniquement si capabilities.appointment (ex. Cabinet Allegra).
import { useState } from "react";
import axios from "axios";
import { CalendarCheck } from "lucide-react";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;
const SLOTS = ["Matin (08h–12h)", "Après-midi (12h–17h)"];

export const FicheAppointment = ({ result: r }) => {
  const [open, setOpen] = useState(false);
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "", reason: "", preferred_date: "", preferred_slot: SLOTS[0] });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async () => {
    if (!form.name.trim() || !form.phone.trim()) { toast.error("Nom et téléphone requis"); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/api/v3/search/doc/${encodeURIComponent(r.id)}/appointment`, form);
      setSent(true);
      toast.success("Demande de rendez-vous envoyée ✓");
    } catch {
      toast.error("Échec de l'envoi — réessayez");
    } finally { setLoading(false); }
  };

  if (sent) return (
    <section style={A.section} data-testid="fiche-appointment-sent">
      <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#34D399", fontWeight: 800, fontSize: 13.5 }}>
        <CalendarCheck size={16} /> Demande envoyée
      </div>
      <p style={{ color: "#9DB4A6", fontSize: 12, margin: "6px 0 0", lineHeight: 1.5 }}>
        Le cabinet vous recontactera au {form.phone} pour confirmer le créneau.
      </p>
    </section>
  );

  return (
    <section style={A.section} data-testid="fiche-appointment">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <h2 style={A.h2}>📅 Prendre rendez-vous</h2>
        {!open && (
          <button onClick={() => setOpen(true)} style={A.cta} data-testid="fiche-appointment-open">
            Demander un rendez-vous
          </button>
        )}
      </div>
      {open && (
        <div style={{ display: "grid", gap: 8, marginTop: 10 }}>
          <input style={A.input} placeholder="Votre nom *" value={form.name} onChange={set("name")} data-testid="apt-name" />
          <input style={A.input} placeholder="Votre téléphone *" value={form.phone} onChange={set("phone")} inputMode="tel" data-testid="apt-phone" />
          <div style={{ display: "flex", gap: 8 }}>
            <input style={{ ...A.input, flex: 1, colorScheme: "dark" }} type="date" value={form.preferred_date} onChange={set("preferred_date")} data-testid="apt-date" />
            <select style={{ ...A.input, flex: 1 }} value={form.preferred_slot} onChange={set("preferred_slot")} data-testid="apt-slot">
              {SLOTS.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <textarea style={{ ...A.input, minHeight: 64, resize: "vertical" }} placeholder="Motif (optionnel) — ex. consultation droit immobilier" value={form.reason} onChange={set("reason")} data-testid="apt-reason" />
          <button onClick={submit} disabled={loading} style={{ ...A.cta, opacity: loading ? 0.6 : 1 }} data-testid="apt-submit">
            {loading ? "Envoi…" : "Envoyer la demande"}
          </button>
        </div>
      )}
    </section>
  );
};

const A = {
  section: { marginTop: 16, padding: 13, borderRadius: 14, background: "rgba(249,115,22,0.07)", border: "1px solid rgba(249,115,22,0.35)" },
  h2: { margin: 0, fontSize: 13.5, fontWeight: 800, color: "#ECF5EE" },
  cta: { padding: "9px 16px", borderRadius: 999, border: "none", background: "#F97316", color: "#1A1206", fontSize: 12.5, fontWeight: 800, cursor: "pointer" },
  input: { padding: "10px 12px", borderRadius: 10, border: "1px solid rgba(16,185,129,0.3)", background: "rgba(4,18,11,0.6)", color: "#ECF5EE", fontSize: 13, outline: "none", width: "100%", boxSizing: "border-box" },
};

export default FicheAppointment;
